import React, { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { Formik, Form } from 'formik'
import FormikControl from '../../Formik/FormikControl'
import * as Yup from 'yup'
import Button from '@material-ui/core/Button'
import { Paper } from '@material-ui/core'
import { SUCCESS, ERROR } from '../constants'
import { applicationService } from '../../Services/ApplicationService'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { useStyles } from './styles'

export function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const Body = (props) => {
  const classes = useStyles()
  const getStateByUtility = (utility) => {
    switch (utility) {
      case 'National Grid, Massachusetts':
        return 'MA'
      case 'National Grid, Rhode Island':
        return 'RI'
      case 'Eversource, Massachusetts':
        return 'MA'
      case 'Eversource, Connecticut':
        return 'CT'
      case 'Cape Light Compact, Massachusetts':
        return 'MA'
      default:
        return 'MA'
    }
  }
  const { headerState, setHeaderState, setLoading } = props
  const [openBodySnackBar, setOpenBodySnackBar] = useState(false)
  const handleBodySnackBarClose = () => {
    setOpenBodySnackBar(false)
  }

  const initialValues = {
    fullName: '',
    fullAddress: '',
    utilityAndState: '',
    quoteDocToHomeOwner: '',
    ConnectedSolutionsApplicationForm: '',
    ConnectedSolutionsTandCForm: '',
    installerName: '',
    installerEmail: '',
    installerCompany: '',
    zip: '',
    state: '',
    city: '',
    email: '',
    checkBox: false,
  }
  const validationSchema = Yup.object({
    fullName: Yup.string()
      .required('*required')
      .matches(/^[a-zA-Z0-9 ]+$/, '*only alphabets and numbers allowed'),
    fullAddress: Yup.string().required('*required'),
    city: Yup.string()
      .required('*required')
      .matches(/^[a-zA-Z0-9 ]+$/, '*only alphabets and numbers allowed'),
    state: Yup.string().required('*required'),
    zip: Yup.string()
      .required('*required')
      .matches(/^[a-zA-Z0-9 ]+$/, '*only alphabets and numbers allowed'),
    email: Yup.string()
      .email('*only valid email formats allowed')
      .required('*required'),
    utilityAndState: Yup.string().required('*required'),
    quoteDocToHomeOwner: Yup.string().required('*required'),
    ConnectedSolutionsApplicationForm: Yup.string().required('*required'),
    ConnectedSolutionsTandCForm: Yup.string().required('*required'),
    installerName: Yup.string()
      .required('*required')
      .matches(/^[a-zA-Z0-9 ]+$/, '*only alphabets and numbers allowed'),
    installerEmail: Yup.string()
      .email('*only valid email formats allowed')
      .required('*required'),
    installerCompany: Yup.string()
      .required('*required')
      .matches(/^[a-zA-Z0-9 ]+$/, '*only alphabets and numbers allowed'),
    checkBox: Yup.boolean().required('*required'),
  })
  const reactOnSubmit = (values, formik) => {
    var data = new FormData()
    const payload = {
      name: values.fullName,
      address: values.fullAddress,
      utility: values.utilityAndState.split(', ')[0],
      state: values.state,
      zip: values.zip,
      city: values.city,
      email: values.email,
      installer_name: values.installerName,
      installer_email: values.installerEmail,
      installer_company: values.installerCompany,
    }
    const json = JSON.stringify(payload)
    const blob = new Blob([json], {
      type: 'application/json',
    })
    data.append('form', blob)
    data.append('quote_form', values.quoteDocToHomeOwner)
    data.append('app_form', values.ConnectedSolutionsApplicationForm)
    data.append('tandc_form', values.ConnectedSolutionsTandCForm)
    submitApplicationForm(data, formik)
  }

  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  const submitApplicationForm = (data, formik) => {
    setLoading(true)
    applicationService.submitApplication(data)
      .then((success) => {
        setLoading(false)
        setHeaderState(SUCCESS)
        setOpenBodySnackBar(true)
        formik.resetForm()
        window.scrollTo(0, 0)
      })
      .catch((error) => {
        setLoading(false)
        setHeaderState(ERROR)
        setOpenBodySnackBar(true)
        window.scrollTo(0, 0)
      })
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={reactOnSubmit}
    >
      {(formik) => (
        <Paper
          elevation={2}
          square={true}
          className={classes.heatLoanFormPaper}
        >
          {openBodySnackBar ? (
            headerState === SUCCESS ? (
              <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openBodySnackBar}
                onClose={handleBodySnackBarClose}
                key={'top' + 'center'}
              >
                <Alert onClose={handleBodySnackBarClose} severity="success">
                  Heat Loan Application Form submitted successfully!
                </Alert>
              </Snackbar>
            ) : (
              <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openBodySnackBar}
                onClose={handleBodySnackBarClose}
                key={'top' + 'center'}
              >
                <Alert onClose={handleBodySnackBarClose} severity="error">
                  Heat Loan Application Form submission unsuccessful!
                </Alert>
              </Snackbar>
            )
          ) : null}
          <Form className={classes.heatLoanFormBody}>
            <Box className={classes.heatLoanFormUserInfo}>
              <FormikControl
                control="select"
                label="Utility and State combination to download ConnectedSolutions Application Forms"
                name="utilityAndState"
                setLoadingTrue={(event) => {
                  setLoading(true)
                }}
                setLoadingFalse={(event) => {
                  setLoading(false)
                }}
                onValueChange={(event) => {
                  formik.setFieldValue('utilityAndState', event.target.value)
                  formik.setFieldValue('state', getStateByUtility(event.target.value))
                }}
                value={formik.values.utilityAndState}
              ></FormikControl>
            </Box>
            <Divider
              variant="middle"
              className={classes.formDividerHomeOwnerDetails}
            />
            <InputLabel classes={{ root: classes.formLabel }}>
              PLEASE FILL HOMEOWNER DETAILS
            </InputLabel>
            <Box className={classes.heatLoanFormUserInfo}>
              <FormikControl
                control="input"
                label="FULL NAME"
                name="fullName"
                inputlabel="Homeowner's Name"
                onValueChange={(event) => {
                  formik.setFieldValue('fullName', event.target.value)
                }}
                value={formik.values.fullName}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormUserInfo}>
              <FormikControl
                control="input"
                label="STREET ADDRESS"
                name="fullAddress"
                inputlabel="Homeowner's street address"
                onValueChange={(event) => {
                  formik.setFieldValue('fullAddress', event.target.value)
                }}
                value={formik.values.fullAddress}
              ></FormikControl>
            </Box>
            <div className={classes.heatLoanFormHODetails}>
              <Box className={classes.heatLoanFormUserInfoHODetails}>
                <FormikControl
                  control="input"
                  label="CITY"
                  name="city"
                  inputlabel="Homeowner's City"
                  onValueChange={(event) => {
                    formik.setFieldValue('city', event.target.value)
                  }}
                  value={formik.values.city}
                ></FormikControl>
              </Box>
              <Box className={classes.heatLoanFormUserInfoHODetails}>
                <FormikControl
                  control="selectstate"
                  label="STATE"
                  name="state"
                  onValueChange={(event) => {
                    formik.setFieldValue('state', event.target.value)
                  }}
                  value={formik.values.state}
                ></FormikControl>
              </Box>
              <Box className={classes.heatLoanFormUserInfoHODetails}>
                <FormikControl
                  control="input"
                  label="ZIP CODE"
                  name="zip"
                  inputlabel="Homeowner's Zip"
                  onValueChange={(event) => {
                    formik.setFieldValue('zip', event.target.value)
                  }}
                  value={formik.values.zip}
                ></FormikControl>
              </Box>
            </div>
            <Box className={classes.heatLoanFormUserInfo}>
              <FormikControl
                control="input"
                type="email"
                label="EMAIL ID"
                name="email"
                inputlabel="Homeowner's Email Id"
                onValueChange={(event) => {
                  formik.setFieldValue('email', event.target.value)
                }}
                value={formik.values.email}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormUserInfoUpload}>
              <FormikControl
                control="document"
                label="ConnectedSolutions Application Form - duly filled and signed by Homeowner"
                name="ConnectedSolutionsApplicationForm"
                onValueChange={(event) => {
                  formik.setFieldValue(
                    'ConnectedSolutionsApplicationForm',
                    event.target.files[0],
                  )
                }}
                value={formik.values.ConnectedSolutionsApplicationForm}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormUserInfoUpload}>
              <FormikControl
                control="document"
                label="ConnectedSolutions Terms and Conditions - signed by Homeowner"
                name="ConnectedSolutionsTandCForm"
                onValueChange={(event) => {
                  formik.setFieldValue(
                    'ConnectedSolutionsTandCForm',
                    event.target.files[0],
                  )
                }}
                value={formik.values.ConnectedSolutionsTandCForm}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormUserInfoUpload}>
              <FormikControl
                control="document"
                label="Quotation - Upload the battery quote provided to Homeowner"
                name="quoteDocToHomeOwner"
                onValueChange={(event) => {
                  formik.setFieldValue(
                    'quoteDocToHomeOwner',
                    event.target.files[0],
                  )
                }}
                value={formik.values.quoteDocToHomeOwner}
              ></FormikControl>
            </Box>
            <Divider
              variant="middle"
              className={classes.formDividerInstallerDetails}
            />
            <InputLabel className={classes.formLabel3}>
              PLEASE FILL YOUR DETAILS - INSTALLER SPECIFIC
            </InputLabel>
            <Box className={classes.heatLoanFormInstallerInfo}>
              <FormikControl
                control="input"
                label="NAME"
                name="installerName"
                inputlabel="Your Name"
                onValueChange={(event) => {
                  formik.setFieldValue('installerName', event.target.value)
                }}
                value={formik.values.installerName}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormInstallerInfo}>
              <FormikControl
                control="input"
                type="email"
                label="EMAIL ID"
                name="installerEmail"
                inputlabel="Your Email"
                onValueChange={(event) => {
                  formik.setFieldValue('installerEmail', event.target.value)
                }}
                value={formik.values.installerEmail}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormInstallerInfo}>
              <FormikControl
                control="input"
                label="COMPANY"
                name="installerCompany"
                inputlabel="Your Company Name"
                onValueChange={(event) => {
                  formik.setFieldValue('installerCompany', event.target.value)
                }}
                value={formik.values.installerCompany}
              ></FormikControl>
            </Box>
            <Divider
              variant="middle"
              className={classes.formDividerInstallerDetails}
            />
            <Box className={classes.heatLoanFormInstallerInfo}>
              <FormikControl
                control="checkbox"
                name="checkBox"
                checked={formik.values.checkBox}
                onValueChange={(checked) => {
                  formik.setFieldValue('checkBox', checked)
                }}
              ></FormikControl>
            </Box>
            <Box className={classes.heatLoanFormSubmit}>
              <Button
                className={classes.heatLoanFormSubmitButton}
                variant="contained"
                type="submit"
                disabled={!formik.values.checkBox}
              >
                Submit
              </Button>
            </Box>
          </Form>
        </Paper>
      )}
    </Formik>
  )
}
export default Body
